import React, { useState, useEffect } from "react";
import "./PopupMenu.css"; // for custom animations
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AiFillShopping } from "react-icons/ai";
import { RiHomeHeartFill, RiWhatsappFill } from "react-icons/ri";
import { BiSupport } from "react-icons/bi";
import { BsBagHeartFill } from "react-icons/bs";
import { MdChromeReaderMode } from "react-icons/md";
import { FaUserDoctor } from "react-icons/fa6";
import { Link } from "react-router-dom";

const PopupMenu = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { pathname } = useLocation();

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setShowMenu(true);
    } else {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`popup-menu ${showMenu ? "visible" : "hidden"}`}>
      <div className="lg:hidden flex relative w-[40%] xl:w-[60%]  h-[65px] ">
        <div className="w-full h-full flex relative gap-3 justify-center items-center bg-mainBg/80 backdrop-blur-md rounded-2xl mt-2 shadow-sm ">
          <Link to="/">
            <img
              src={`${process.env.REACT_APP_CLIENT_URL}/images/logoBi.png`}
              alt="logo"
              className="w-[50px] mr-3"
            />
          </Link>
          <div
            onClick={() => navigate("/")}
            className={`mobile-b-icons  ${
              pathname === "/" ? "bg-thirdColor text-white " : "text-slate-600"
            }`}
          >
            <RiHomeHeartFill className="text-3xl" />
          </div>
          <div
            onClick={() => navigate("/doctors")}
            className={`mobile-b-icons  ${
              pathname === "/doctors"
                ? "bg-thirdColor text-white"
                : "text-slate-600"
            }`}
          >
            <FaUserDoctor className="text-2xl" />
          </div>
          <div
            onClick={() => navigate("/our-products")}
            className={`mobile-b-icons  ${
              pathname === "/our-products"
                ? "bg-thirdColor text-white"
                : "text-slate-600"
            }`}
          >
            <BsBagHeartFill className="text-2xl " />
          </div>

          <div
            onClick={() => navigate("/blogs")}
            className={`mobile-b-icons  ${
              pathname === "/blogs"
                ? "bg-thirdColor text-white"
                : "text-slate-600"
            }`}
          >
            <MdChromeReaderMode className="text-2xl" />
          </div>
          <div
            onClick={() => navigate(userInfo ? "/card" : "/login")}
            className={`mobile-b-icons  ${
              pathname === "/card"
                ? "bg-thirdColor text-white"
                : "text-slate-600"
            }`}
          >
            <span className="text-2xl">
              <AiFillShopping />
            </span>
            {card_product_count !== 0 && (
              <div className="w-[20px] h-[20px] absolute bg-green-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                {card_product_count}
              </div>
            )}
          </div>

          <div
            onClick={() => navigate("/contact")}
            className={`mobile-b-icons  ${
              pathname === "/contact"
                ? "bg-thirdColor text-white"
                : "text-slate-600"
            }`}
          >
            <BiSupport className="text-3xl" />
          </div>
          <div className="mobile-b-icons text-thirdColor border-2 border-thirdColor">
            <Link
              className="w-full h-full text-3xl flex justify-center items-center"
              to="https://wa.me/qr/4RIJE7RR7MEUH1"
              target="_blank"
            >
              <RiWhatsappFill />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupMenu;
